import { PropsWithChildren } from 'react'

export const NotificationsProvider = ({
  children
}: PropsWithChildren<unknown>) => {
  return <>{children}</>
}
